import React from 'react';
import Helmet from 'react-helmet';
import Joi from 'joi';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { useFieldset, useDispatchCallback } from 'controls/hooks';
import { forgotPassword } from 'actions/auth';
import { getParam } from 'controls/utils';
import { Container } from 'components/layout/Container';
import { Input } from 'components/atoms/Input/Input';
import { Button } from 'components/atoms/Button/Button';
import { Header } from 'components/atoms/Header/Header';
import { Language } from 'language/Language';
import { getUrlToRedirect } from './utils';
import { strings } from './strings';
import './_ForgotPassword.scss';
import 'styles/_form.scss';

const ForgotForm = { email: '' };
const ForgotSchema = { email: Joi.string().max(50).required().label('email') };

const ForgotPassword = () => {
  const { isWorking } = useSelector((state) => state.siteInfo);
  const { fields: { email }, submit } = useFieldset({
    schema: ForgotSchema,
    source: ForgotForm,
    onSubmit: useDispatchCallback(forgotPassword),
  });
  const language = Language();
  const redirectTo = getParam('redirectTo');
  return (
    <>
      <Helmet title='Forgot password - Walkmix Creator' />
      <Container style={{ textAlign: 'center' }}>
        <Header style={{ textAlign: 'center' }} text={strings[language].title} />
        <h3 className='forgot__text'>{strings[language].hero}</h3>
        <form onSubmit={submit} className='form forgot-form'>
          <div className='input-container'>
            <label>{strings[language].label}</label>
            <Input
              field={email}
              classes='input forgot__input'
              name='email'
              label
            />
          </div>
          <Button
            className='forgot__btn'
            isWorking={isWorking}
            text={strings[language].button}
            type='submit'
          />
          <Link to={getUrlToRedirect(redirectTo)} style={{ fontSize: '18px', textAlign: 'center' }}>{strings[language].back}</Link>
        </form>
      </Container>
    </>
  );
};

export default ForgotPassword;
